import $http from '../../shared/http';
import moment from 'moment';

export const logs = {
  namespaced: true,
  state: () => {
    return {
      loginRecords: [],
    };
  },
  getters: {
    getLoginRecords: (state) => state.loginRecords,
  },
  mutations: {
    setLoginRecords: (state, data) => {
      state.loginRecords = data;
    },
  },
  actions: {
    async loadLoginRecords({ commit }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get('/loginRecords')
          .then((response) => {
            //console.log(response)
            commit('setLoginRecords', response.data.loginRecords);
            resolve(response);
          })
          .catch((error) => {
            //console.log(error)
            reject(error);
          });
      });
    },
    async storeLoginRecord(ctx, email) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post('/loginRecords', { loginTime: moment().format('YYYY-MM-DD HH:mm:ss'), email })
          .then((response) => {
            console.log(response);
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
  },
};
